var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"filters--list mb-4"},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"6","lg":"3"}},[_c('FilterDates',{attrs:{"fetchData":_vm.fetchMovements,"dateRange":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }